/**
 * Como um lead sai das abas terminais e volta ao board (CRM-08).
 *
 * Arquivado e perdido sao estados diferentes, e cada um tem o seu endpoint:
 *   - /reativar desfaz a perda E desarquiva (lead:perder);
 *   - /desarquivar so desarquiva — um lead perdido continua perdido (lead:edit).
 * A aba Arquivados mistura os dois casos; chamar /desarquivar num lead
 * perdido e anunciar "Lead reativado." deixava o lead sumido do board.
 */
import { desarquivarLead, reativarLead } from "../../services/crm";

export const ACAO_REATIVAR = {
  chave: "reativar",
  permissao: ["lead:perder"],
  fn: reativarLead,
  label: "Reativar",
  emAndamento: "Reativando…",
  sucesso: "Lead reativado.",
};

export const ACAO_DESARQUIVAR = {
  chave: "desarquivar",
  permissao: ["lead:edit"],
  fn: desarquivarLead,
  label: "Desarquivar",
  emAndamento: "Desarquivando…",
  sucesso: "Lead desarquivado.",
};

/** Acao que devolve `lead` ao pipeline na aba `tipo`, ou null (somente leitura). */
export function acaoDeRetorno(tipo, lead) {
  if (tipo === "ganhos") return null;
  if (tipo === "perdidos") return ACAO_REATIVAR;
  return lead?.perdido_em ? ACAO_REATIVAR : ACAO_DESARQUIVAR;
}
